import {Component, OnInit} from '@angular/core';

import {TipoPoder} from '../../../models/tipo-poder.model';
import {CatalogosService} from '../../../services/catalogos.service';

@Component({
  templateUrl: './lista-inscripcion-contratos.component.html',
  styleUrls: ['./lista-inscripcion-contratos.component.css']
})
export class ListaInscripcionContratosComponent implements OnInit {

  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio'
    },
    {
      label: 'Inscripción de contratos',
      routerLink: '/contratos'
    }
  ];

  tipos: TipoPoder[];
  loading = false;

  constructor(private catalogosService: CatalogosService) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposContratos().subscribe((tipos) => {
      this.loading = false;
      const array: any[] = [];
      tipos.map((p, key) => {
        // Seleccionando inscripcion de contratos de la funcion getTiposPoderes
        const descripcion = p.descripcion.toString();
        // if (descripcion.includes('contrato')) {
          array.push(p);
        // }
      });
      this.tipos = array;
    });
  }
}
